
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import EssaiModel from '@/models/EssaiModel'
import CheckboxYesNo from '@/components/common/CheckboxYesNo.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import convertDateDirective from '@/directives/convertDateDirective'
import {isCoprolibDate} from '@/helpers/validators'
import {required} from 'vuelidate/lib/validators'

@Component({
  components: {
    BaseFormContainer,
    CheckboxYesNo,
    SelectRef
  },
  directives: {
    convertDateDirective
  },
  validations: {
    form: {
      ID_CONTACT: {
        required
      },
      DATE_DEBUT_ESSAI: {
        isCoprolibDate
      },
      DATE_FIN_ESSAI: {
        isCoprolibDate
      }
    }
  }
})
export default class EssaiForm extends BaseForm {
  @Prop(Array) contacts!: object[]
  model = EssaiModel

  get contactsFilterByEmail() {
    if (!this.contacts) return null
    const contacts = this.contacts.filter((item: any) => item.EMAIL !== null)
    return contacts
  }

  getLabel({NOM, PRENOM, EMAIL}) {
    if (NOM && PRENOM) return `${PRENOM} ${NOM}`
    else if (NOM) return `${NOM}`
    else if (PRENOM) return `${PRENOM}`
    else return EMAIL
  }
}
